import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormMultiSelect from '../_shared/forms/FormMultiSelect';
import SubmitButton from '../_shared/SubmitButton';

export default class TipOffs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tipOffs: this.props.tipOffs,
            loading: false,
        };
    }

    handleMultiSelectChange = (value) => {
        this.setState({
            tipOffs: value,
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
        });

        let formData = new FormData();

        formData.append('tip_offs', this.state.tipOffs ? JSON.stringify(this.state.tipOffs) : []);

        axios
            .post(`/providers/${this.props.providerId}/tip-offs`, formData)
            .then((res) => {
                console.log(res);
                toastr.success('Tip Offs saved successfully');
                this.setState({
                    loading: false,
                });
            })
            .catch((err) => {
                console.log(err);
                toastr.error('There was a problem while trying to save tip offs, please try again later');
                this.setState({
                    loading: false,
                });
            });
    };

    render() {
        return (
            <div>
                <div className="col-12">
                    <form onSubmit={this.onSubmit}>
                        <FormMultiSelect
                            label=""
                            options={this.props.tipOffOptions}
                            handleMultiSelectChange={(value) => this.handleMultiSelectChange(value)}
                            classes={'form-control'}
                            prefixes={this.state.tipOffs}
                        />

                        <SubmitButton
                            buttonText="Save Tip Offs"
                            loading={this.state.loading}
                            style={{ width: 200, marginTop: 20 }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

if (document.getElementById('provider-tip-offs')) {
    let element = document.getElementById('provider-tip-offs');

    ReactDOM.render(
        <TipOffs
            tipOffs={JSON.parse(element.dataset.tip_offs)}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            providerId={element.dataset.provider_id}
        />,
        element
    );
}
